class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    if (window.RocaCartUpsell) window.RocaCartUpsell.refresh();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

/* RoCa Healthcare cart upsell — existing Shopify free-shipping rule remains unchanged */
(() => {
  const FREE_SHIPPING_THRESHOLD = 6000;
  const SYLLIFLOR_VARIANTS = [
    { id: 40811067244701, label: 'Malt' },
    { id: 40811067211933, label: 'Vanilla' },
    { id: 40811089854621, label: 'Apple & Cinnamon' },
  ];

  let refreshTimer;
  let isAdding = false;

  const money = (cents) =>
    new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' }).format(cents / 100);

  const ensureStyles = () => {
    if (document.getElementById('roca-cart-upsell-styles')) return;
    const style = document.createElement('style');
    style.id = 'roca-cart-upsell-styles';
    style.textContent = `
      .roca-cart-upsell{margin:1.2rem 0 1.4rem;padding:1.3rem;border:1px solid rgba(var(--color-foreground),.14);border-radius:10px;background:rgba(var(--color-foreground),.035);text-align:left}
      .roca-cart-upsell__message{margin:0 0 .8rem;font-size:1.35rem;line-height:1.4}
      .roca-cart-upsell__message strong{font-weight:700}
      .roca-cart-upsell__bar{height:7px;border-radius:999px;background:rgba(var(--color-foreground),.12);overflow:hidden;margin:.2rem 0 1rem}
      .roca-cart-upsell__fill{height:100%;background:rgb(var(--color-button));border-radius:inherit;transition:width .25s ease}
      .roca-cart-upsell__label{display:block;margin:.3rem 0 .7rem;font-size:1.2rem;opacity:.78}
      .roca-cart-upsell__buttons{display:flex;flex-wrap:wrap;gap:.6rem}
      .roca-cart-upsell__add{appearance:none;border:1px solid rgba(var(--color-foreground),.28);border-radius:999px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));padding:.65rem 1rem;font:inherit;font-size:1.2rem;line-height:1;cursor:pointer}
      .roca-cart-upsell__add:hover{border-color:rgba(var(--color-foreground),.65)}
      .roca-cart-upsell__add:disabled{opacity:.55;cursor:wait}
      .roca-cart-upsell--success{padding:1.05rem 1.3rem}
      .roca-cart-upsell--success .roca-cart-upsell__message{margin:0}
      .cart-notification .roca-cart-upsell{margin-top:.8rem}
      @media(max-width:749px){.roca-cart-upsell__buttons{gap:.5rem}.roca-cart-upsell__add{padding:.65rem .85rem}}
    `;
    document.head.appendChild(style);
  };

  const getTargets = () => {
    const targets = [];
    const notificationLinks = document.querySelector('#cart-notification .cart-notification__links');
    const cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (notificationLinks) targets.push(notificationLinks);
    if (cartBlocks) targets.push(cartBlocks);
    return targets;
  };

  const buildMarkup = (cart) => {
    if (!cart || cart.item_count === 0) return '';
    const remaining = Math.max(FREE_SHIPPING_THRESHOLD - cart.total_price, 0);
    const progress = Math.min((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100, 100);

    if (remaining === 0) {
      return `<div class="roca-cart-upsell roca-cart-upsell--success"><p class="roca-cart-upsell__message">✓ You’ve unlocked <strong>FREE delivery</strong></p></div>`;
    }

    const buttons = SYLLIFLOR_VARIANTS.map(
      (variant) => `<button type="button" class="roca-cart-upsell__add" data-roca-variant="${variant.id}">+ ${variant.label}</button>`
    ).join('');

    return `
      <div class="roca-cart-upsell">
        <p class="roca-cart-upsell__message">You’re only <strong>${money(remaining)}</strong> away from <strong>FREE delivery</strong>.</p>
        <div class="roca-cart-upsell__bar" aria-hidden="true"><div class="roca-cart-upsell__fill" style="width:${progress}%"></div></div>
        <span class="roca-cart-upsell__label">Add another SylliFlor flavour:</span>
        <div class="roca-cart-upsell__buttons">${buttons}</div>
      </div>`;
  };

  const render = async () => {
    ensureStyles();
    const targets = getTargets();
    if (!targets.length) return;

    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return;
      const cart = await response.json();
      const markup = buildMarkup(cart);

      targets.forEach((target) => {
        const existing = target.querySelector(':scope > .roca-cart-upsell');
        if (!markup) {
          existing?.remove();
          return;
        }
        if (existing) {
          const holder = document.createElement('div');
          holder.innerHTML = markup.trim();
          existing.replaceWith(holder.firstElementChild);
        } else {
          target.insertAdjacentHTML('afterbegin', markup);
        }
      });
    } catch (error) {
      console.error('RoCa cart upsell:', error);
    }
  };

  const refresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(render, 100);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.roca-cart-upsell__add');
    if (!button || isAdding) return;
    event.preventDefault();
    event.stopPropagation();
    isAdding = true;
    document.querySelectorAll('.roca-cart-upsell__add').forEach((el) => (el.disabled = true));

    try {
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(button.dataset.rocaVariant), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('Unable to add product');
      window.location.href = window.routes?.cart_url || '/cart';
    } catch (error) {
      isAdding = false;
      document.querySelectorAll('.roca-cart-upsell__add').forEach((el) => (el.disabled = false));
      console.error('RoCa cart upsell:', error);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  window.RocaCartUpsell = { refresh };
})();
